// don't start until page is interactive
document.addEventListener('DOMContentLoaded', function () {
  // Init variables
  let lastScrollPos = 0;
  let isTicking = false;

  // Element Selectors
  const stickyContainer = document.getElementById('product-sticky-container');
  const stickyMain = document.getElementById('product-sticky-main');
  const stickyInner = document.getElementById('product-sticky-inner');
  if (!stickyContainer || !stickyMain || !stickyInner) return;

  const buttonsContainer = stickyContainer.querySelector('.js-buy-buttons');
  const buttonAddItem = buttonsContainer.querySelector('[name=add]');
  const stickyHeader = document.querySelector('sticky-header');

  // The scroll listener needed for scroll-direction logic
  window.addEventListener('scroll', () => {
    if (!isTicking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        isTicking = false;
      });
      isTicking = true;
    }
  });

  function handleScroll() {
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight - 1 : 0;
    const scrollPos = window.scrollY;

    // scroll-direction dependent logic
    if (window.innerWidth >= 990) {
      stickyMain.classList.remove('hidden-at-page-bottom');
      stickyMain.style.top = scrollPos < lastScrollPos ? `${stickyHeaderHeight}px` : '0';
    } else {
      stickyMain.style.top = ''; // Reset desktop view value
      // Hide the sticky buy bar at the very bottom of the page to allow customers to access the footer
      const documentHeight = document.documentElement.scrollHeight;
      stickyMain.classList.toggle('hidden-at-page-bottom', documentHeight - scrollPos - window.innerHeight <= 50);
    }
    lastScrollPos = scrollPos;
  }

  /**
   * When user is at the top of the page and btn not visible in viewport yet,
   * this script enables the floating add-to-cart mode.
   */
  const handleButtonIntersection = (entries) => {
    entries.forEach((entry) => {
      const isButtonInViewport = entry.isIntersecting;
      const isStickyBarActive = stickyMain.classList.contains('appears-sticky');
      const shouldBeFloating = !isStickyBarActive && !isButtonInViewport;
      stickyMain.classList.toggle('floating-add-to-cart', shouldBeFloating);
      document.body.classList.toggle('has-floating-add-to-cart', shouldBeFloating);
    });
  };

  // Manages the main sticky bar state
  const handleStickyIntersection = (entries) => {
    entries.forEach((entry) => {
      const isContainerAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;

      if (isContainerAboveViewport) {
        // enter sticky mode
        if (!stickyMain.classList.contains('appears-sticky')) {
          stickyContainer.style.height = `${stickyMain.offsetHeight}px`;
          const variantPickers = stickyContainer.querySelectorAll('.js-variant-option-picker');
          variantPickers.forEach((variantPicker) => updateVariantSelector(variantPicker));
          document.body.classList.add('has-sticky-buy-bar');
          stickyMain.classList.add('appears-sticky');
          stickyInner.classList.add('page-width--wide');
        }
      } else {
        // exit sticky mode
        if (stickyMain.classList.contains('appears-sticky')) {
          stickyContainer.removeAttribute('style');
          document.body.classList.remove('has-sticky-buy-bar');
          stickyMain.classList.remove('appears-sticky');
          stickyInner.classList.remove('page-width--wide');
          // clear event handled inside sticky view
          const productForm = stickyContainer.querySelector('product-form');
          const variantRadios = stickyContainer.querySelector('variant-radios');
          if (productForm?.onVariantChanged && variantRadios) {
            variantRadios.removeEventListener('variant:changed', productForm.onVariantChanged);
          }
        }
      }
    });
  };

  // Create and start the observers
  const stickyObserver = new IntersectionObserver(handleStickyIntersection, { threshold: 0 });
  const btnObserver = new IntersectionObserver(handleButtonIntersection, { threshold: 0 });
  stickyObserver.observe(stickyContainer);
  btnObserver.observe(buttonsContainer);

  // Syncs dropdowns with pill-style variant selectors
  function updateVariantSelector(variantPicker) {
    // Find the currently selected variant from the pill-style radio inputs
    const activeVariant = variantPicker.querySelector('input[type=radio]:checked');
    const activeVariantValue = activeVariant?.value;
    if (activeVariantValue) {
      // Find the currently selected option in the dropdown
      const dropdownSelectedOption = variantPicker.querySelector('.dropdown-select .option.selected');
      // If the dropdown is out of sync, update its display and selected state
      if (!dropdownSelectedOption || dropdownSelectedOption.dataset.optionValue != activeVariantValue) {
        variantPicker.querySelector('.dropdown-selected .text').textContent = activeVariantValue;
        dropdownSelectedOption?.classList.remove('selected');
        variantPicker
          .querySelector(`.dropdown-select [data-option-value="${activeVariantValue}"]`)
          ?.classList.add('selected');
      }
    }
  }
});
